// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidenav {
  width: 230px;
  position: fixed;
  z-index: 1;
  top: 110px;
  left: 150px;
  background: white;
  overflow-x: hidden;
  padding: 8px 0;
}

.sidenav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 25px;
  color: #2196F3;
  display: block;
}

.sidenav a:hover {
  color: #064579;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }
  .sidenav a {
    font-size: 18px;
  }
}
.navigation-items {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

mat-toolbar {
  border-radius: 3px;
}

.icon {
  display: inline-block;
  width: 32px;
  height: 32px;
}

.icon svg {
  width: 32px !important;
  height: 32px !important;
}

ul#menu li {
  display: inline;
  padding: 5px;
}

/* Lighter backgrounds to match header style */
.saved-filters, .recent-searches, .recently-viewed, .popular-searches,
.price-alerts, .compare-list, .quick-stats,
.tools-panel {
  margin-bottom: 12px;
  padding: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(212, 175, 55, 0.2);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
}

.tools-panel:hover {
  box-shadow: 0 6px 25px rgba(212, 175, 55, 0.15);
  border-color: rgba(212, 175, 55, 0.4);
}

.tools-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  margin: 0;
  padding: 12px 14px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  color: inherit;
}
.tools-panel-header h3, .tools-panel-header h6 {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  text-shadow: none !important;
  flex: 1 1 auto;
  color: var(--brand-accent, #d4af37);
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-weight: 300;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.tools-panel-header .mat-icon {
  flex: 0 0 auto;
  color: rgba(0, 0, 0, 0.45);
}
.tools-panel-header:hover .mat-icon {
  color: var(--brand-accent, #d4af37);
}

.tools-panel-body {
  padding: 0 14px 14px;
}

.tools-panel.is-collapsed {
  box-shadow: none;
}

.saved-filters:hover, .recent-searches:hover, .recently-viewed:hover,
.popular-searches:hover, .price-alerts:hover, .compare-list:hover,
.quick-stats:hover {
  /* hover handled by .tools-panel:hover */
}

.saved-filters h3, .recent-searches h6, .recently-viewed h6,
.popular-searches h6, .price-alerts h6, .compare-list h6, .quick-stats h6 {
  color: var(--brand-accent, #d4af37);
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-weight: 300;
  font-size: 14px;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 12px;
  text-shadow: 0 1px 2px rgba(212, 175, 55, 0.3);
  border-bottom: 1px solid rgba(212, 175, 55, 0.2);
  padding-bottom: 4px;
}

.recent-item, .compare-item, .stat {
  color: #333;
  font-weight: 300;
  transition: all 0.3s ease;
}

.recent-item:hover, .compare-item:hover {
  color: #d4af37;
  background: rgba(212, 175, 55, 0.1);
}

/* Selected saved filter buttons */
::ng-deep .saved-filters mat-chip-option.mat-mdc-chip-selected {
  background: #1a1a1a !important;
  color: white !important;
}

::ng-deep .saved-filters mat-chip-option.mat-mdc-chip-selected mat-icon {
  color: white !important;
}

/* Alternative if using mat-chip */
::ng-deep .saved-filters mat-chip.mat-mdc-chip-selected {
  background: #1a1a1a !important;
  color: white !important;
}

aside.col-sm-12 {
  padding: 16px;
  background: transparent;
  overflow-y: auto;
  /* Hide scrollbar */
  -ms-overflow-style: none;
  scrollbar-width: none;
}
aside.col-sm-12::-webkit-scrollbar {
  display: none;
}

::ng-deep .mat-mdc-menu-panel.full-width-menu {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(212, 175, 55, 0.2) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
  min-width: calc(100% - 32px) !important;
  max-width: 500px !important;
}

::ng-deep .full-width-menu .mat-mdc-menu-content {
  padding: 16px !important;
}

::ng-deep .full-width-menu h6 {
  color: #d4af37 !important;
  font-family: "Helvetica Neue", Arial, sans-serif !important;
  font-weight: 300 !important;
  font-size: 14px !important;
  letter-spacing: 1px !important;
  text-transform: uppercase !important;
  margin-bottom: 12px !important;
  text-shadow: 0 1px 2px rgba(212, 175, 55, 0.3) !important;
  border-bottom: 1px solid rgba(212, 175, 55, 0.2) !important;
  padding-bottom: 4px !important;
}

::ng-deep .full-width-menu .filter-item {
  color: #333 !important;
  font-weight: 300 !important;
  padding: 8px 0 !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
}

::ng-deep .full-width-menu .filter-item:hover {
  color: #d4af37 !important;
  background: rgba(212, 175, 55, 0.1) !important;
  padding-left: 4px !important;
}

::ng-deep .full-width-menu strong {
  color: #666 !important;
  font-weight: 400 !important;
}

@media (max-width: 959px) {
  mat-toolbar {
    border-radius: 0px;
  }
}
.tools-empty {
  margin: 0;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 1.4;
}

.rightbar-tools {
  padding: 0;
}

.recent-item .item-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.recent-thumb {
  width: 44px;
  height: 44px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  flex: 0 0 auto;
}

.recent-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.recent-text .item-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
}

.recent-text .item-price {
  font-size: 12px;
  font-weight: 700;
  color: #111;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/listing-browse-ui/rightbar/rightbar.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE;IAAU,iBAAA;EAEV;EADA;IAAY,eAAA;EAIZ;AACF;AAFA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AAIF;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AAIF;;AADA;EACE,sBAAA;EACA,uBAAA;AAIF;;AADA;EACE,eAAA;EACA,YAAA;AAIF;;AADA,8CAAA;AACA;;;EAGE,mBAAA;EACA,UAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mBAAA;EACA,yCAAA;EACA,wDAAA;EACA,gBAAA;AAIF;;AADA;EACE,+CAAA;EACA,qCAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAIF;AAFE;EACE,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;EACA,mCAAA;EACA,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AAIJ;AADE;EACE,cAAA;EACA,0BAAA;AAGJ;AAAE;EACE,mCAAA;AAEJ;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;;;EAGE,wCAAA;AACF;;AAEA;;EAEE,mCAAA;EACA,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,gDAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,mCAAA;AACF;;AAGA,kCAAA;AACA;EACE,8BAAA;EACA,uBAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAGA,kCAAA;AACA;EACE,8BAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EAEA,mBAAA;EAIA,wBAAA;EACA,qBAAA;AAJF;AAAE;EACE,aAAA;AAEJ;;AAIA;EACE,gDAAA;EACA,sCAAA;EACA,oDAAA;EACA,8BAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;AADF;;AAIA;EACE,wBAAA;AADF;;AAIA;EACE,yBAAA;EACA,2DAAA;EACA,2BAAA;EACA,0BAAA;EACA,8BAAA;EACA,oCAAA;EACA,8BAAA;EACA,yDAAA;EACA,2DAAA;EACA,8BAAA;AADF;;AAIA;EACE,sBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,oCAAA;AADF;;AAIA;EACE,yBAAA;EACA,8CAAA;EACA,4BAAA;AADF;;AAIA;EACE,sBAAA;EACA,2BAAA;AADF;;AAIA;EACE;IACE,kBAAA;EADF;AACF;AAIA;EACE,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qCAAA;EACA,cAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAFF;;AAKA;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAFF","sourcesContent":[".sidenav {\n  width: 230px;\n  position: fixed;\n  z-index: 1;\n  top: 110px;\n  left: 150px;\n  background: white;\n  overflow-x: hidden;\n  padding: 8px 0;\n}\n\n.sidenav a {\n  padding: 6px 8px 6px 16px;\n  text-decoration: none;\n  font-size: 25px;\n  color: #2196F3;\n  display: block;\n}\n\n.sidenav a:hover {\n  color: #064579;\n}\n\n@media screen and (max-height: 450px) {\n  .sidenav {padding-top: 15px;}\n  .sidenav a {font-size: 18px;}\n}\n\n.navigation-items{\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\nmat-toolbar{\n  border-radius: 3px;\n}\n\n.icon {\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n}\n\n.icon svg {\n  width: 32px !important;\n  height: 32px !important;\n}\n\nul#menu li {\n  display:inline;\n  padding: 5px;\n}\n\n/* Lighter backgrounds to match header style */\n.saved-filters, .recent-searches, .recently-viewed, .popular-searches,\n.price-alerts, .compare-list, .quick-stats,\n.tools-panel {\n  margin-bottom: 12px;\n  padding: 0;\n  background: rgba(255,255,255,0.95);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(212,175,55,0.2);\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.1);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  overflow: hidden;\n}\n\n.tools-panel:hover {\n  box-shadow: 0 6px 25px rgba(212,175,55,0.15);\n  border-color: rgba(212,175,55,0.4);\n}\n\n.tools-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  margin: 0;\n  padding: 12px 14px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  color: inherit;\n\n  h3, h6 {\n    margin: 0 !important;\n    padding: 0 !important;\n    border: none !important;\n    text-shadow: none !important;\n    flex: 1 1 auto;\n    color: var(--brand-accent, #d4af37);\n    font-family: 'Helvetica Neue', Arial, sans-serif;\n    font-weight: 300;\n    font-size: 14px;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n  }\n\n  .mat-icon {\n    flex: 0 0 auto;\n    color: rgba(0, 0, 0, 0.45);\n  }\n\n  &:hover .mat-icon {\n    color: var(--brand-accent, #d4af37);\n  }\n}\n\n.tools-panel-body {\n  padding: 0 14px 14px;\n}\n\n.tools-panel.is-collapsed {\n  box-shadow: none;\n}\n\n.saved-filters:hover, .recent-searches:hover, .recently-viewed:hover,\n.popular-searches:hover, .price-alerts:hover, .compare-list:hover,\n.quick-stats:hover {\n  /* hover handled by .tools-panel:hover */\n}\n\n.saved-filters h3, .recent-searches h6, .recently-viewed h6,\n.popular-searches h6, .price-alerts h6, .compare-list h6, .quick-stats h6 {\n  color: var(--brand-accent, #d4af37);\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  font-weight: 300;\n  font-size: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n  text-shadow: 0 1px 2px rgba(212,175,55,0.3);\n  border-bottom: 1px solid rgba(212,175,55,0.2);\n  padding-bottom: 4px;\n}\n\n.recent-item, .compare-item, .stat {\n  color: #333;\n  font-weight: 300;\n  transition: all 0.3s ease;\n}\n\n.recent-item:hover, .compare-item:hover {\n  color: #d4af37;\n  background: rgba(212,175,55,0.1);\n}\n\n\n/* Selected saved filter buttons */\n::ng-deep .saved-filters mat-chip-option.mat-mdc-chip-selected {\n  background: #1a1a1a !important;\n  color: white !important;\n}\n\n::ng-deep .saved-filters mat-chip-option.mat-mdc-chip-selected mat-icon {\n  color: white !important;\n}\n\n/* Alternative if using mat-chip */\n::ng-deep .saved-filters mat-chip.mat-mdc-chip-selected {\n  background: #1a1a1a !important;\n  color: white !important;\n}\n\naside.col-sm-12 {\n  padding: 16px;\n  background: transparent;\n  overflow-y: auto;\n\n  /* Hide scrollbar */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n::ng-deep .mat-mdc-menu-panel.full-width-menu {\n  background: rgba(255,255,255,0.95) !important;\n  backdrop-filter: blur(10px) !important;\n  border: 1px solid rgba(212,175,55,0.2) !important;\n  border-radius: 12px !important;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.1) !important;\n  min-width: calc(100% - 32px) !important;\n  max-width: 500px !important;\n}\n\n::ng-deep .full-width-menu .mat-mdc-menu-content {\n  padding: 16px !important;\n}\n\n::ng-deep .full-width-menu h6 {\n  color: #d4af37 !important;\n  font-family: 'Helvetica Neue', Arial, sans-serif !important;\n  font-weight: 300 !important;\n  font-size: 14px !important;\n  letter-spacing: 1px !important;\n  text-transform: uppercase !important;\n  margin-bottom: 12px !important;\n  text-shadow: 0 1px 2px rgba(212,175,55,0.3) !important;\n  border-bottom: 1px solid rgba(212,175,55,0.2) !important;\n  padding-bottom: 4px !important;\n}\n\n::ng-deep .full-width-menu .filter-item {\n  color: #333 !important;\n  font-weight: 300 !important;\n  padding: 8px 0 !important;\n  font-size: 14px !important;\n  transition: all 0.3s ease !important;\n}\n\n::ng-deep .full-width-menu .filter-item:hover {\n  color: #d4af37 !important;\n  background: rgba(212,175,55,0.1) !important;\n  padding-left: 4px !important;\n}\n\n::ng-deep .full-width-menu strong {\n  color: #666 !important;\n  font-weight: 400 !important;\n}\n\n@media(max-width: 959px){\n  mat-toolbar{\n    border-radius: 0px;\n  }\n}\n\n.tools-empty {\n  margin: 0;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.5);\n  line-height: 1.4;\n}\n\n.rightbar-tools {\n  padding: 0;\n}\n\n.recent-item .item-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.recent-thumb {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  flex: 0 0 auto;\n}\n\n.recent-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.recent-text .item-name {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.recent-text .item-price {\n  font-size: 12px;\n  font-weight: 700;\n  color: #111;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
